::ng-deep app-people-and-roles-dialogue{display:flex;flex-grow:1;height:calc(100% - 30px)}
/*# sourceMappingURL=people-and-roles-dialogue.component-X5VBSCUG.css.map */
